<template>
  <div class="active_page">
    <img class="img_bg" :src="ainfo.background_pic" />
    <!-- <div class="location_box">
      <img class="active_local_img" :src="img.active_local">
      <div>全国</div>
      <div class="top_active_name">全国卡丁车圈速赛</div>
    </div> -->
    <div class="active_form_box">
      <div class="audit_title">{{ainfo.title}}</div>
      <div class="form_box">
        <div class="input_cell">
          <div class="input_name">
            <div class="request_star">*</div>
            姓名/昵称
          </div>
          <div class="input_form">
            <van-field v-model="params.name" placeholder="填写姓名/昵称" />
          </div>
        </div>
        <div class="input_cell">
          <div class="input_name">
            <div class="request_star">*</div>
            手机号
          </div>
          <div class="input_form">
            <van-field v-model="params.mobile" placeholder="填写手机号" maxlength='11' type='tel' />
          </div>
        </div>
        <div class="input_cell">
          <div class="input_name">
            <div class="request_star">*</div>
            合伙类型
          </div>
          <div class="input_form">
            <van-radio-group v-model="params.is_family" style="height: 32px;display: flex;align-items: center;justify-content: space-between;margin:0 15px;">
              <van-radio checked-color="#1E2A75" icon-size="16px" class="radio_sef_cls" name="1">供应商</van-radio>
              <van-radio checked-color="#1E2A75" icon-size="16px" class="radio_sef_cls" name="2">分销商</van-radio>
            </van-radio-group>
          </div>
        </div>
        
      </div>
    </div>
    <div class="active_fixed_btn">
      <div class="fix_btn" @click="nextStep()">{{ainfo.ticket_text?ainfo.ticket_text:'提交报名信息'}}</div>
    </div>
  </div>
</template>

<script>
  import post from '../../../api/toyota/api';
  import { mapState } from 'vuex';
  import {Field,Uploader,Toast,Radio,RadioGroup } from 'vant';
  export default {
    data () {
      return {
        hid:25,
        ainfo:'',
        info:'',
        params:{
          name:'',
          mobile:'',
          is_family:'',
          city:'1',
          picture:'123',
        },
        imgcover_url:'',
        img:{
          active_local: require('../../../assets/img/toyota/active/active_local.png')
        }
      }
    },
    created () {
      this.getActiveInfo()

    },
    methods: {
      getActiveInfo(){
        post.getActiveInfo({
          id:this.hid
        }).then(res => {
          if(res.data.state==1){
            this.ainfo=res.data.data
            document.title = res.data.data.title;
          } else {
            Toast(res.data.error[0]);
            return false
          }
        })
      },
      
      nextStep(){
        var that=this
        that.params.hid=this.hid
        post.activePost(that.params).then(res => {
          if(res.data.state==1){
            Toast.success('提交成功');
            setTimeout(function() {
              window.location.href ='https://m.motortime.com/subaru/active/fenxiaoaudit?token='+res.data.data.token+'&scene='+new Date().getTime()
              that.params={
                name:'',
                mobile:'',
                is_family:'',
                city:'1',
                picture:'123',
              }
            },1300)
          } else {
            Toast(res.data.error[0]);
            return false
          }
        })    
      },

    },
    components: {
      [Field.name]: Field,
      [Uploader.name]: Uploader,
      [Toast.name]:Toast,
      [Radio.name]:Radio,
      [RadioGroup.name]:RadioGroup
    }
  };
</script>

<style lang="scss">
  .active_page {
    height: 100vh;
    overflow-y: hidden;
    position:relative;
    .active_form_box{
      width: 100%;
      position: absolute;
      top: 0;
      bottom:0;
      z-index: 2;
    }
    .img_bg{
      width: 100%;
      position: absolute;
      top: 0;
      bottom:0;
      z-index: 1;
    }
    .audit_title{
      color: #1E2A75;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin-top: 10%;
      margin-bottom: 25px;
    }
    // .location_box {
    //   position:sticky;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   z-index: 2;
    //   font-size: 12px;
    //   padding: 20px 20px;
    //   display: flex;
    //   align-items: center;
    //   background-color:rgba(255,255,255,0.5);
    //   // border-bottom: 1px solid #F1F1F1;
    //   // border-top: 1px solid #F1F1F1;

    //   .active_local_img {
    //     width: 25px;
    //     height: 24px;
    //     margin-right: 15px;
    //   }

    //   .top_active_name {
    //     color: #333333;
    //     font-size: 16px;
    //     margin-left: 15px;
    //   }
    // }
    .form_box {
      border: 2px solid #1E2A75;
      background-color: #E7EAF9;
      border-radius: 2px;
      padding: 0 20px;
      margin: 20px;
      .input_cell {
        display: flex;
        align-items: center;
        margin: 60px 0;

      }

      .input_name {
        color: #fff;
        font-size: 12px;
        background-color: #1E2A75;
        width: 75px;
        height: 32px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border: 2px solid #1E2A75;

      }
      .input_img_name{
        color: #fff;
        font-size: 12px;
        background-color: #1E2A75;
        width: 75px;
        height: 118px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border: 2px solid #1E2A75;
      }
      .request_star {
        color: red;
        font-size: 12px;
        width: 12px;
      }

      .input_form {
        flex: 1;
        height: 32px;
        border: 2px solid #1E2A75;
        .van-cell{
          height: 32px;
          padding: 0 15px;
          font-size: 12px;
          display: flex;
          align-items:center;
        }

      }
      .input_img_form{
        display: flex;
        align-items: center;
        flex: 1;
        height: 118px;
        border: 2px solid #1E2A75;
        .van-uploader__upload{
          background-color: #eaeaea;
          border-radius: 0;
          margin: 0;
          margin-left: 15px;
        }
        .input_img_form_text{
          font-size: 10px;
          color: #9a9a9a;
          margin-left: 10px;
        }
        .van-uploader__upload{
          width: 90px;
          height: 90px;
        }
      }
      .one_camera {
        width: 25px;
        height: 22px;
        margin-top: 35%;
      }

      .one_form {
        display: flex;
        align-items: center;
        margin-left: 20px;
      }

      .one_img {
        width: 90px;
        height: 90px;
        color: #666666;
        background-color: #EEEEEE;
        margin-right: 10px;
      }

      .one_img_pic {
        width: 90px;
        height: 90px;
        margin-left: 15px;
        object-fit: cover;
      }

    }
    .active_fixed_btn{
      width: 100%;
      position: fixed;
      bottom: 80px;
      margin-top:25px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      .fix_btn{
        text-align: center;
        background-color: #1E2A75;
        color: #fff;
        border-radius: 25px;
        font-size: 14px;
        padding: 12px 0;
        width: 150px;
      }
    }
    .radio_sef_cls{
      font-size: 14px;
    }
  }
</style>
